import type { IframeManagerConfig } from './iframe-manager.types'
import { waitForDocumentLoad } from '../../utils/wait-for-document-load'

export class IframeManager {
  public iframe!: HTMLIFrameElement
  private config: IframeManagerConfig
  private defaultIframeConfig: Partial<HTMLIFrameElement> = {
    width: '100%',
    height: '100%',
    id: 'xpaid-wallet-iframe',
    allow: 'clipboard-write',
  }

  constructor(config: IframeManagerConfig) {
    this.config = config
  }

  public async init(): Promise<HTMLIFrameElement> {
    await waitForDocumentLoad()

    this.createIframe()
    this.appendTo()

    return this.iframe
  }

  public destroy() {
    if (!this.iframe)
      return

    this.iframe.remove()
  }

  private createIframe() {
    if (this.iframe)
      return

    this.iframe = document.createElement('iframe')
    Object.assign<HTMLIFrameElement, Partial<HTMLIFrameElement>>(this.iframe, {
      ...this.defaultIframeConfig,
      ...this.config,
    })
  }

  private appendTo() {
    const container = document.getElementById(this.config.containerId)

    if (container) {
      container.appendChild(this.iframe)
    }
    else {
      throw new Error('[Xpaid Wallet SDK] => Please enter a valid containerId')
    }
  }
}
